/** ฝ่ามือมังกรทอง (lane C4 skeleton): gold + fire, motif rays. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const GOLDENDRAGON_FX: ReturnType<typeof makeHandArt> = makeHandArt('golden-dragon-palm', { a: 'gold', b: 'fire', motif: 'rays' }, [
  ['dp9-burst', 'palm', 2],
  ['dp9-lance', 'palm', 5],
  ['dp9-twin', 'palm', 6],
  ['dp9-rend', 'fist'],
  ['dp9-stomp', 'buff'],
  ['dp9-whirl', 'ring', 4],
  ['dp9-double', 'palm', 2],
  ['dp9-sky', 'power', 6],
]);
